import React, { useState } from 'react';

import Popover from '@mui/material/Popover';

import Chip from 'components/Chip';

import { RiskMatrixContainer, RiskMatrixWrapper, getColor } from './styles';
import { RiskMatrixProps } from './types';
import RiskMatrixTable from './RiskMatrixTable';

const RiskMatrix = ({ impact, likelihood, risk, editable, updateRisk }: RiskMatrixProps): React.ReactElement => {
  // State for managing the popover anchor element
  const [anchorEl, setAnchorEl] = useState<HTMLElement | null>(null);
  // State for tracking the selected cell values
  const [selectedCell, setSelectedCell] = useState({ impact, likelihood, risk });

  // Handler for opening the matrix popover
  const handleOpen = (event: React.MouseEvent<HTMLElement>): void => {
    if (editable) {
      setAnchorEl(event.currentTarget);
    }
  };

  // Handler for closing the matrix popover
  const handleClose = (): void => {
    setAnchorEl(null);
  };

  const open = Boolean(anchorEl);

  return (
    <RiskMatrixWrapper>
      {/* Compact view showing current risk assessment values */}
      <RiskMatrixContainer onClick={handleOpen}>
        <Chip label={selectedCell.impact} size="medium" sx={{ width: '44px' }} />
        <Chip label={selectedCell.likelihood} size="medium" sx={{ width: '44px' }} />
        <Chip
          label={selectedCell.risk}
          size="medium"
          sx={{ width: '44px' }}
          colors={{
            background: getColor(selectedCell.impact, selectedCell.likelihood).bg,
            foreground: getColor(selectedCell.impact, selectedCell.likelihood).color,
          }}
        />
      </RiskMatrixContainer>
      {/* Popover containing the full risk matrix for selection */}
      <Popover
        open={open}
        anchorEl={anchorEl}
        onClose={handleClose}
        anchorOrigin={{
          vertical: 'top',
          horizontal: 'right',
        }}
        transformOrigin={{
          vertical: 'top',
          horizontal: 'left',
        }}
      >
        <RiskMatrixTable
          selected={selectedCell}
          onChange={(newSelectedCell) => {
            setSelectedCell(newSelectedCell);
            updateRisk?.(newSelectedCell.impact, newSelectedCell.likelihood);
          }}
        />
      </Popover>
    </RiskMatrixWrapper>
  );
};

export default RiskMatrix;
